import { AuthModalsOpenState } from 'components/RoutingProvider';
import React from 'react';

export interface AuthStateContext {
  email: string;
  open: AuthModalsOpenState;
}

export const AuthStateContext = React.createContext<AuthStateContext>({} as AuthStateContext);
